import {COLORS} from '@aboutyou/ui-components';
import {range} from '@aboutyou/utils';
import React, {FC} from 'react';
import styled from 'styled-components';

interface Props {
  scrollToSlide: (index: number) => void;
  currentSlide: number;
  count: number;
  className?: string;
}

export const SliderDottedNavigation: FC<Props> = ({
  currentSlide,
  className,
  count,
  scrollToSlide,
}) => {
  if (!count) {
    return null;
  }

  return (
    <Wrapper className={className}>
      {range(0, count).map((_, index) => {
        return (
          <SliderDottedNavigationItem
            key={`SliderDottedNavigationItem-${index}`}
            $isActive={currentSlide === index}
            onClick={() => scrollToSlide(index)}
          />
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
  flex-shrink: 0;
  overflow-y: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: transparent;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
`;

const SliderDottedNavigationItem = styled.li<{$isActive: boolean}>`
  height: 8px;
  width: 8px;
  background-color: ${COLORS.Grey1};
  opacity: ${({$isActive}) => ($isActive ? 0.8 : 0.2)};
  cursor: ${({$isActive}) => ($isActive ? 'default' : 'pointer')};
  border-radius: 50%;
  display: inline-block;

  &:not(:last-child) {
    margin-right: 6px;
  }
`;
